import React from "react";
import { useParams, Link } from "react-router-dom";
import { useState } from "react";
import { PrintInstructions } from "./printInstructions";
import { BuildInstructions } from "./buildInstructions";
import { Comments } from "./comments";
import { apiClient } from "sessions/server";

export const Project = () => {
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState("print");
    const [specsOpen, setSpecsOpen] = useState(false);
    const [prototype, setPrototype] = React.useState(null);

    React.useEffect(() => {
        apiClient
            .get(`/prototype/printable/${id}/`)
            .then((response) => setPrototype(response.data))
            .catch((error) =>
                console.error("Error retrieving prototype:", error)
            );
    }, []);

    if (!prototype) {
        return (
            <main>
                <section className="section">
                    <div className="container">
                        <h1 className="section-title">Prototype Not Found</h1>
                        <p className="lead">
                            Sorry, this prototype doesn't exist.
                        </p>
                        <Link to="/goodies" className="btn btn-primary">
                            Back to Prototypes
                        </Link>
                    </div>
                </section>
            </main>
        );
    }

    return (
        <main>
            <section className="section">
                <div className="container">
                    <Link to="/goodies" className="breadcrumb">
                        ← Back to Prototypes
                    </Link>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <div className="tabs">
                        <button
                            className={`tab-button ${
                                activeTab === "print" ? "active" : ""
                            }`}
                            onClick={() => setActiveTab("print")}
                        >
                            Print Instructions
                        </button>
                        <button
                            className={`tab-button ${
                                activeTab === "build" ? "active" : ""
                            }`}
                            onClick={() => setActiveTab("build")}
                        >
                            Build Instructions
                        </button>
                        <button
                            className={`tab-button ${
                                activeTab === "comments" ? "active" : ""
                            }`}
                            onClick={() => setActiveTab("comments")}
                        >
                            Comments
                        </button>
                    </div>

                    <div className="tab-content">
                        {activeTab === "build" && (
                            <BuildInstructions
                                build_steps={prototype?.build_steps || []}
                                hardware_list={prototype?.hardware_list || []}
                            />
                        )}

                        {activeTab === "print" && (
                            <PrintInstructions
                                prototype={prototype}
                                specsOpen={specsOpen}
                                setSpecsOpen={setSpecsOpen}
                            />
                        )}
                        {activeTab === "comments" && <Comments />}
                    </div>
                </div>
            </section>
        </main>
    );
};
